import {BifrostBackendApi} from "../../gateways/BifrostBackendApi";

const IdpManagementProvider = {
	async deleteUserFromIdp(tenantId, token) {
		const idpManagementQueryParams = {
			tenantId
		};
		return BifrostBackendApi.delete(`/auth0-management/remove`, {
			params: idpManagementQueryParams,
			headers: {
				Authorizationidp: token
			}
		});
	}
};

export default Object.freeze(IdpManagementProvider);
